<template>
  <div>
    <v-card flat style="border-radius:1px">
      <v-card-title primary-title>
        <div class="headline mb-0">Departamentos</div>
      </v-card-title>
      <v-card-text>
        <v-alert v-if="loading_depts" type="info" :value="true">
          Carregando... 
          <v-progress-linear color='white' :indeterminate="true"></v-progress-linear>
        </v-alert>
        <v-treeview 
          v-if="!loading_depts && all_departments"
          hoverable 
          shaped 
          activatable 
          :items="all_departments"
          :open.sync="open"
          :active.sync="active"
          :active-class="'grey lighten-3 font-weight-bold'"
          ref="treeDepto"
          dense
        >
          <template v-slot:append="{ item, active, open}">
            <v-btn v-if="active" class="btn_add" color='purple' icon @click="addChild(item)">
              <v-icon v-if="active" >mdi-plus</v-icon>
            </v-btn>
            <v-btn v-if="active" icon color='blue' @click="editDept(item)">
              <v-icon v-if="active" >mdi-circle-edit-outline</v-icon>
            </v-btn>
          </template>
        </v-treeview>
      </v-card-text>
      <v-card-actions class="justify-end" v-if="false">
        <v-btn flat text color="error">Cancelar</v-btn>
        <v-btn flat text color="primary">OK</v-btn>
      </v-card-actions>
    </v-card>

    <department-dialog v-if="dialog_department" :one_department="one_department" @close="handleCloseDepartment" @done="handleDoneDepartment"></department-dialog>

  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api'

export default {
  name: 'DepartmentsList',
  components: {
    DepartmentDialog: () => import('./DialogDepartment'),
  },
  data() {
    return {
      key: null,
      loading_depts: false,
      active: [],
      open: [1],
      dialog_department: false,
      one_department: null,
    }
  },
  methods: {
    handleDoneDepartment(e){
      this.dialog_department = false
      // console.log({e});
      this.one_department = null
      this.getDepartments()
    },
    handleCloseDepartment(e){
      this.dialog_department = false
      this.one_department = null
    },
    getDepartments(){
      this.loading_depts = true
      this.indexDepartments().then(() => {
        this.loading_depts = false
      })
    },
    addChild(item){
      setTimeout(() => {
        this.active = [item.id]
      }, 100);
      this.dialog_department = true
      this.one_department = { //;
        name: null,
        parent_id: item.id,
        parent_name: item.name
      }
    },
    editDept(item){
      this.dialog_department = true
      this.one_department = {...item}
    },
    ...mapActions({
      indexDepartments: 'Department/index'
    })
  },
  mounted () {
    this.getDepartments();
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      all_departments: state => state.Department.all_departments
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>
